import { getSnapshot, applySnapshot } from 'mobx-state-tree';

const STORAGE_KEY = 'MAGIC_LIFE_COUNTER_STATE';

export class PersistenceService {
    rootStore: any;

    constructor(rootStore: any) {
        this.rootStore = rootStore;
    }

    async saveState() {
        try {
            const snapshot = getSnapshot(this.rootStore);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
            console.log('State saved successfully');
        } catch (error) {
            console.error('Error saving state:', error);
        }
    }

    async loadState() {
        try {
            const stateString = localStorage.getItem(STORAGE_KEY);

            if (stateString) {
                const snapshot = JSON.parse(stateString);
                applySnapshot(this.rootStore, snapshot);
                console.log('State loaded successfully');
                return true;
            }
            return false;
        } catch (error) {
            console.error('Error loading state:', error);
            return false;
        }
    }

    async clearState() {
        try {
            localStorage.removeItem(STORAGE_KEY);
            console.log('State cleared successfully');
        } catch (error) {
            console.error('Error clearing state:', error);
        }
    }
}

export function createPersistenceService(store: any) {
    return new PersistenceService(store);
}
